import Vue from 'vue'
import VueRouter from 'vue-router'
import Access from '@/modules/Access.vue'
import ChangePassword from '@/modules/ChangePassword.vue'
import Dashboard from '@/modules/Dashboard.vue'
import Deliveries from '@/modules/Deliveries.vue'
import Downloads from '@/modules/Downloads.vue'
import Loading from '@/modules/Loading.vue'
import Logout from '@/modules/Logout.vue'
import Unauthorized from '@/modules/Unauthorized.vue'
import Welcome from '@/modules/Welcome.vue'
import Message from '@/modules/Message.vue'
import Profile from '@/modules/Profile.vue'
import NewSubscription from '@/modules/NewSubscription.vue'
import Subscription from '@/modules/Subscription.vue'
import Subscriptions from '@/modules/Subscriptions.vue'
import TransbankResult from '@/modules/TransbankResult.vue'
import Reports from '@/modules/Reports.vue'

Vue.use(VueRouter)

const routes = [
	{ path: '/access', name: 'Access', component: Access },
	{ path: '/changepassword/:token', name: 'ChangePassword', component: ChangePassword, props: true },
	{ path: '/dashboard', name: 'Dashboard', component: Dashboard },
	{ path: '/loading', name: 'Loading', component: Loading },
	{ path: '/logout', name: 'Logout', component: Logout },
	{ path: '/unauthorized', name: 'Unauthorized', component: Unauthorized },
	{
		path: '/', name: 'Welcome', component: Welcome,
		children: [
			{ path: '/message', name: 'Message', component: Message },
			{ path: '/profile', name: 'Profile', component: Profile },
			{ path: '/newsubscription', name: 'NewSubscription', component: NewSubscription },
			{ path: '/reports', name: 'reports', component: Reports },
			{ path: '/deliveries', name: 'Deliveries', component: Deliveries },
			{ path: '/downloads', name: 'Downloads', component: Downloads },
			{ path: '/subscription/:token', name: 'Subscription', component: Subscription, props: true },
			{ path: '/subscriptions', name: 'Subscriptions', component: Subscriptions },
			{ path: '/transbankresult/:action/:token', name: 'TransbankResult', component: TransbankResult, props: true },
		]
	},
	{ path: '*', redirect: '/' }
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
